/**
 * @author lifei
 * 功能：应用基础类，应用的基础信息等
 */
/* eslint-disable no-use-before-define */
import { VARS } from '@/conf'

export class Base {
  /**
   * 功能：用于 nginx 代理和转发
   */
  protected get proxy_api(): string {
    return VARS.PROXY_API
  }

  /**
   * 功能：用于访问后端地址
   */
  protected get proxy_https(): string {
    return VARS.PROXY_HTTPS
  }

  /**
   * 功能：前缀
   */
  protected get prefix(): string {
    return VARS.PREFIX
  }

  /**
   * 功能：组织名称、公司名称
   */
  protected get orgName(): string {
    return VARS.ORG_NAME
  }

  /**
   * 功能：接口 api 上下文 context
   */
  protected get apiContext(): string {
    return VARS.API_CONTEXT
  }

  private static sonClasses: (typeof Base)[] = []

  /**
   * 功能：收集子类
   * @param sonclass
   */
  protected static register = (sonclass: typeof Base): void => {
    if (!this.sonClasses.includes(sonclass)) {
      this.sonClasses.push(sonclass)
    } else {
      throw new Error(`sonclass is already registered: ${sonclass.name}' `)
    }
  }
}
